(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
const required = require('@clocklimited/validity-required')

module.exports = function () {
  return schemata(
    { date:
      { type: Date
      , validators:
        { all: [ required ]
        }
      }
    , airline:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , flightNumber:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , bookingReference:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , arrival:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , departure:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , notes:
      { type: String
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/itinerary/flight-schema.js","/components/service/itinerary")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9pdGluZXJhcnkvZmxpZ2h0LXNjaGVtYS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJ2YXIgc2NoZW1hdGEgPSByZXF1aXJlKCdzY2hlbWF0YScpXG5jb25zdCByZXF1aXJlZCA9IHJlcXVpcmUoJ0BjbG9ja2xpbWl0ZWQvdmFsaWRpdHktcmVxdWlyZWQnKVxuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uICgpIHtcbiAgcmV0dXJuIHNjaGVtYXRhKFxuICAgIHsgZGF0ZTpcbiAgICAgIHsgdHlwZTogRGF0ZVxuICAgICAgLCB2YWxpZGF0b3JzOlxuICAgICAgICB7IGFsbDogWyByZXF1aXJlZCBdXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAsIGFpcmxpbmU6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgLCB2YWxpZGF0b3JzOlxuICAgICAgICB7IGFsbDogWyByZXF1aXJlZCBdXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAsIGZsaWdodE51bWJlcjpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICwgYm9va2luZ1JlZmVyZW5jZTpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICwgYXJyaXZhbDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICwgZGVwYXJ0dXJlOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBub3RlczpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgfVxuICApXG59XG4iXX0=